/**
@format
@flow local-strict
*/
import React from 'react';
import { ContentContainer as KrispyContentContainer } from '@krispy/layout/web';
import Constants from './Constants';

type Props = $ReadOnly<{
  /**
   * If content passed in needs
   * to be stacked vertically
   * Default is when content
   * is stacked horizontally
   */
  isVertical?: boolean,

  /**
   * Offset top
   * Default 96px or height
   * of navHeader
   */
  offsetTop?: number,

  /**
   * Content passed in wrapper
   */
  children: any,
}>;

export default function ContentWrapper(props: Props): React$Node {
  return <KrispyContentContainer {...props} />;
}

ContentWrapper.defaultProps = {
  isVertical: false,
  offsetTop: Constants.layoutSpaceLarge,
};
